import React from 'react';
import Register from '../components/Authentication/Register';

const RegisterPage = () => {
	return <Register />;
};

export default RegisterPage;
